import { render, staticRenderFns } from "./Examination.vue?vue&type=template&id=67018c3c&scoped=true&"
import script from "./Examination.vue?vue&type=script&lang=ts&"
export * from "./Examination.vue?vue&type=script&lang=ts&"
import style0 from "./Examination.vue?vue&type=style&index=0&id=67018c3c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67018c3c",
  null
  
)

export default component.exports